import { mountTelemetryRoot } from "@workwave-tidal/core/telemetry";
const sym = Symbol.for("\u2026");
const checkLicense = (options) => {
  const { product, env, license } = options;
  if (window[sym]) {
    return;
  }
  Object.defineProperty(window, sym, {
    configurable: false,
    enumerable: false,
    value: { isValid: true, license, product, env }
  });
  const obj = window[sym];
  if (obj) {
    Object.freeze(obj);
  }
};
function registerTidal(options) {
  mountTelemetryRoot(options);
  if (document.readyState !== "loading") {
    checkLicense(options);
  } else {
    window.addEventListener("DOMContentLoaded", () => checkLicense(options));
  }
}
export {
  registerTidal
};
//# sourceMappingURL=index.js.map
